import { Injectable } from '@angular/core';
import { BehaviorSubject, from, iif, Observable } from "rxjs";
import { ApiConfigService } from "../../../shared-services/api-config.service";
import { map, switchMap, tap } from "rxjs/operators";
import { MonumentDto } from "../../../dtos/monumentDto";

@Injectable({
    providedIn: 'root'
})
export class MonumentsDataService {

    private _monuments: BehaviorSubject<Array<MonumentDto>> = new BehaviorSubject<any>([]);
    public readonly monuments: Observable<Array<MonumentDto>> = this._monuments.asObservable();

    constructor(private apiConfigService: ApiConfigService) {
    }

    getMonumentBySiteId(siteId: number): Observable<Array<MonumentDto>> {
        return this._monuments
            .asObservable()
            .pipe(
                switchMap((monuments) =>
                    iif(() => MonumentsDataService.areSiteMonumentFetched(monuments, siteId),
                        this.monuments,
                        this.apiConfigService.get<MonumentDto[]>(`api/site/${siteId}/monuments`)
                            .pipe(
                                tap((elements: any) => {
                                    this._monuments.next([...this.getMonumentData(), ...elements]);
                                })
                            )
                    )
                ),
                map((monuments: Array<MonumentDto>) => monuments.filter((monument) => monument.siteId === siteId))
            );
    }

    getAllMonumentData(): Observable<Array<MonumentDto>> {
        return this._monuments
            .asObservable()
            .pipe(
                switchMap((monuments) =>
                    iif(() => MonumentsDataService.areMonumentFetched(monuments),
                        this.monuments,
                        this.apiConfigService.get<MonumentDto[]>('api/monument/all')
                            .pipe(
                                tap((elements: any) => {
                                    this._monuments.next([...this.getMonumentData(), ...elements]);
                                })
                            )
                    )
                )
            );
    }

    //Static synchronous access of observable. Beware you are responsible to know that the data has been fetched.
    getMonumentData() {
        return this._monuments.getValue();
    }

    private static areSiteMonumentFetched(monuments: MonumentDto[], siteId: number): boolean {
        return !!monuments.find((el) => el.siteId === siteId);
    }

    private static areMonumentFetched(monuments: MonumentDto[]): boolean {
        return monuments.length > 0;
    }
}